import React from 'react';
import Main from "./MyComponents/main";
// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

function App() {
  return (
    <>
    <Main />
    </>
  );
}

export default App;
